import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./http-client";
import { MerchantRequest } from "@/models/merchant";
import { MerchantDetailModel } from "@/models/terminal";

const baseUrl = `${process.env.REACT_APP_API_ENDPOINT_Portal}/v1/merchant`;

function createMerchant(
    model: MerchantRequest
  ): Promise<AxiosResponse<MerchantRequest>> {
    const url = `${baseUrl}/add`;
    return postAsync(url, model, true, true);
  }

  function getMerchant(id: string, locationId?: string): Promise<AxiosResponse<MerchantDetailModel>> {
    const url = `${baseUrl}/${id}/${locationId}`;
    return getAsync(url);
  }

  function updateMerchant(
    id: string,
    model: MerchantRequest
  ): Promise<AxiosResponse<MerchantRequest>> {
    const url = `${baseUrl}/update/${id}`;
    return putAsync(url, model, true, true);
  }

  function activateMerchant(id: string, isDeactive?: boolean) {
    const url = `${baseUrl}/active/${id}/${isDeactive}`;
    return putAsync(url, undefined, true, true);
  }

  function removeMerchant(id: string) {
    const url = `${baseUrl}/${id}`;
    return deleteAsync(url, undefined, true, true);
  }

export const MerchantApi = {
    createMerchant,
    getMerchant,
    updateMerchant,
    activateMerchant,
    removeMerchant,
}